var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.prov && _vm.prov.setup)?_c('page',{staticClass:"pt-6",attrs:{"id":_vm.$route.params.id,"remote":_vm.remoteFunc,"remote-option":_vm.dynamicData,"scriptforge-endpoint":"/api/softphone/scriptforge","page-endpoint":"/api/softphone/page"},on:{"on-change":_vm.onChange,"on-input-change":_vm.onInputChange}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }